import { SiteCurrency } from './locale'
import { intitalTotmPayment, TotmPayment } from './totm/interrail/totmOrder'

export interface PaymentOrder {
  bankID?: number
  KlarnaTermsAndConditions?: boolean
  customPayment?: CustomPayment
  TermsAndConditions: boolean
  UseBanconactApp: boolean
  TotmPayment: TotmPayment
}

export interface CardOrder {
  CardNumber?: string
  CardHolderName: string
  ExpirationMonth?: number
  ExpirationYear?: number
  CVC?: number
}

export interface GiftCard {
  amount: number | null
  bonus: number | null
}
export interface CustomPayment {
  Description: string
  Currency: SiteCurrency
  Total: number
  paymentToken: string
  dueDate: Date | null
  isValid: boolean
  giftCards?: GiftCard[]
}

export const initialPayment: PaymentOrder = {
  TermsAndConditions: false,
  UseBanconactApp: false,
  TotmPayment: intitalTotmPayment,
}
